import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import authReducer from 'src/reducers/authReducer';
import commonReducer from 'src/reducers/commonReducer';
import currentActionReducer from '../reducers/actionsReducer';
import permissionsReducer from '../reducers/permissionsReducer'
import saveGridModalReducer from 'src/reducers/gridLayoutReducer';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ["oidc", "walletAddress"]
}
const rootReducer = combineReducers({
  oidc: authReducer,
  AdminData: commonReducer,
  permissions: permissionsReducer,
  currentAction: currentActionReducer,
  gridLayout: saveGridModalReducer,
})
const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk]
})
export const persister = persistStore(store);
export default store